export default "__VITE_ASSET__CJfVaf30__"